export default async function SectionProjectListings(el, {
    locations,
}) {
    // Calculate the center of the coordinates.
    // default coords is Flournoy main office
    let centerLat = 32.536768806870874;
    let centerLng = -84.97792387427064;

    const validLocations = locations.filter(location => location.lat && location.lng);

    if (validLocations.length > 0) {
        const { sumLat, sumLng } = validLocations.reduce((acc, location) => ({
            sumLat: acc.sumLat + location.lat,
            sumLng: acc.sumLng + location.lng,
        }), { sumLat: 0, sumLng: 0 });

        centerLat = sumLat / validLocations.length;
        centerLng = sumLng / validLocations.length;
    }

    const center = { lat: centerLat, lng: centerLng };

    /* eslint-disable no-undef */
    const { LatLngBounds } = await google.maps.importLibrary('core');
    const { Map } = await google.maps.importLibrary('maps');
    const { Marker } = await google.maps.importLibrary('marker');
    /* eslint-enable no-undef */

    const mapContainer = el.querySelector('div');
    const bounds = new LatLngBounds(center);
    const map = new Map(mapContainer, {
        mapId: '6e94772a02954502b7f2b4c6',
        zoom: validLocations.length === 1 ? 15 : 6,
        center,
        disableDefaultUI: true,
        zoomControl: true,
    });

    validLocations.forEach(({ lat, lng, title }) => {
        const marker = new Marker({
            position: { lat, lng },
            map,
            title,
            icon: '/images/map-pin.svg',
        });

        bounds.extend(marker.position);
    });
}
